import React from "react";
import { Link } from "react-router";
import AuthCheck from "../../../../utils/AuthCheck";
import ProtectedLink from "../../../../components/ProtectedLink";
import Pagination from "../../../../components/Pagination";

function GeoservicesTable({
  geoservices,
  onDelete,
  type,
  page,
  totalPages,
  totalItems,
  onPageChange,
}) {
  return (
    <div>
      <div className="responsive-scroll" tabIndex="0">
        <table className="table">
          <thead>
            <tr>
              <th scope="col-4" className="tb-text">
                TEMÁTICA
              </th>
              <th scope="col-4" className="tb-text text-center">
                SERVICIO DE MAPAS WEB
              </th>
              <th scope="col-4" className="tb-text text-center">
                SERVICIO DE VECTORES WEB
              </th>
              <ProtectedLink
                funcionalidadesRequeridas={[
                  "Editar Geoservicio",
                  "Eliminar Geoservicio",
                ]}
              >
                <th scope="col text-center" className="tb-button">
                  ACCIONES
                </th>
              </ProtectedLink>
            </tr>
          </thead>
          <tbody>
            {geoservices?.map((geoservice) => (
              <tr key={geoservice.id}>
                <td className="col-4">{geoservice.descripcion}</td>
                <td className="text-center col-4">
                  {geoservice.link_wms ? (
                    <a
                      className="text-dark"
                      href={geoservice.link_wms}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="text-dark">WMS</span>
                    </a>
                  ) : null}
                </td>
                <td className="text-center col-4">
                  {geoservice.link_wfs ? (
                    <a
                      className="text-dark"
                      href={geoservice.link_wfs}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="text-dark">WFS</span>
                    </a>
                  ) : null}
                </td>
                <ProtectedLink
                  funcionalidadesRequeridas={[
                    "Editar Geoservicio",
                    "Eliminar Geoservicio",
                  ]}
                >
                  <td>
                    <div className="actions-table">
                      <AuthCheck
                        funcionalidadesRequeridas={["Editar Geoservicio"]}
                      >
                        <Link
                          to={`/editar-geoservicio/${geoservice.id}`}
                          className="btn btn-xs"
                        >
                          <span
                            className="material-symbols-rounded o-icon"
                            aria-hidden="true"
                          >
                            edit
                          </span>
                        </Link>
                      </AuthCheck>
                      <AuthCheck
                        funcionalidadesRequeridas={["Eliminar Geoservicio"]}
                      >
                        <button
                          type="button"
                          className="btn btn-xs"
                          onClick={() => onDelete(geoservice.id, type)}
                        >
                          <i className="bx bxs-trash-alt o-icon"></i>
                        </button>
                      </AuthCheck>
                    </div>
                  </td>
                </ProtectedLink>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">
          Total: {totalItems}{" "}
          {totalItems === 1 ? "geoservicio" : "geoservicios"}
        </small>
      </div>
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
}

export default GeoservicesTable;
